<template>
    <div class="two">
        <div>
            <img src="../../assets/solution1.png" alt="">
            <img src="../../assets/solution2.png" alt="">
            <img src="../../assets/solution3.png" alt="">
        </div>
        <p>我们将行业进行细分，根据您的具体情况，帮助您制定专属营销方案，让您提升交易量轻松卖货。</p>
    </div>
</template>
<script>
    export default {
        name: 'one'
    }
</script>
<style scoped>
    .two{
        position: relative;
        top: -480px;
        width: 658px;
        margin: 0 auto;
    }
    div{
        overflow: hidden;
    }
    div>img{
        float: left;
        margin: 0 10px;
        width: 30%;
    }
    p{
        font-size: 14px;
        color: #e5e5e5;
        text-align: center;
        padding-top: 20px;
        width: 690px;
    }

</style>
</style>


// WEBPACK FOOTER //
// src/components/indexr/two.vue